import ApiFactory from '@/factories/ApiFactory'
// import { serialize } from '@/utilities/querySerialize'

export default {
  getConfigs() {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/configurations?`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        ).catch(e => reject(e))
    })
  },
  updateConfigs(configs) {
    let { id } = configs
    return new Promise((resolve, reject) => {
      ApiFactory.put(`v1/configurations/${id}`, configs)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        ).catch(e => reject(e))
    })
  },
}
